import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-hypermetro",
  "use": "app-icon-hypermetro-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-hypermetro\"><path d=\"M8.692 9.876h-2l-.28.95h-1.82l2.15-5.73h1.93l2.16 5.73h-1.83l-.31-.95zm-.37-1.23l-.63-2.06-.63 2.06h1.26zm7.1-1.22l-3.88-2.4 1-.56a6 6 0 00-10.39 1.28H.002a8 8 0 0114.26-2.29l1-.56.1 2.78a.14.14 0 000 .07l.06 1.68zM.002 8.566l3.88 2.4-1 .56a6 6 0 0010.39-1.28h2.13a8 8 0 01-14.25 2.29l-1 .56-.15-2.78a.25.25 0 010-.07h.06l-.06-1.68z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol